export enum UserTabChildPages {
  PROFILE = "profile",
  BILLING = "billing",
  SETTINGS = "settings",
  API_KEYS = "api-keys",
  WORKSPACES = "workspaces",
}
